import React from "react";
import "./loading.css";

function Loading({ title }) {
  return (
    <div className="loading-container">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
        {title && <div className="loading-title">{title}</div>}
    </div>
  );
}

export default React.memo(Loading);
